import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

interface LoginValues {
  email: string;
  password: string;
}

interface UseLoginReturn {
  values: LoginValues;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (e: React.FormEvent) => void;
  message: string;
}

export const useLogin = ({ initialValues }: { initialValues: LoginValues }): UseLoginReturn => {
  const [values, setValues] = useState<LoginValues>(initialValues);
  const [message, setMessage] = useState<string>("");
  const navigate = useNavigate(); 
  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/api/login`;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(""); 
    try {
      const response = await axios.post(url, values);
      localStorage.setItem("token", response.data.token);
      localStorage.setItem('name', response.data.name);
      localStorage.setItem('role', response.data.role);
      setMessage("Login successful!");
      navigate("/admin/users"); 
    } catch (err) {
      setMessage("Invalid email or password");
    }
  };

  return { values, handleChange, handleSubmit, message };
};
